module.exports = __webpack_public_path__ + "static/media/maestro.c969d2b0.svg";